import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {HttpService} from "../../../shared/services/http/http-client.service";
import { NotificationsService } from 'angular2-notifications';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {

  headerInformation = null;
  travelBalances = {
    saldoCreditoPlano: 0,
    creditoPortal: 0,
    emissaoCartao: 0,
    saldoEstorno: 0,
    saldoGastoCartao: 0,
    saldoValorReservado: 0,
    saldoDisponivel: 0,
  };

  constructor(private http: HttpClient,
              private httpService: HttpService,
              private notificationsService: NotificationsService,
              ) { }


  assignHeaderInformation(headerInformation: any) {
    this.headerInformation = headerInformation;
  }

  getHeaderInformation() {
    return this.headerInformation;
  }

  updateHeaderProductDescription(productDescription: any) {
    this.headerInformation.productDescription = productDescription;
  }

  updateHeaderEnterpriseName(enterpriseName: any) {
    this.headerInformation.enterpriseName = enterpriseName;
  }

  updateHeaderProductId(productId: any) {
    this.headerInformation.productId = productId;
  }

  getTravelBalances() {
    this.httpService.doGet('/enterprise/travel/travelBalanceStatement', null, (response) => {
      this.travelBalances.saldoCreditoPlano = response.creditoPlano;
      this.travelBalances.creditoPortal = response.creditoPortal;
      this.travelBalances.emissaoCartao = response.emissaoCartao;
      this.travelBalances.saldoEstorno = response.estornoPlano;
      this.travelBalances.saldoGastoCartao = response.gastosCartoes;
      this.travelBalances.saldoValorReservado = response.valorReservado;
      this.travelBalances.saldoDisponivel = response.saldoDisponivel;
    }, error => {
      this.notificationsService.error(error.message);});
  }
  
}
